<template>
  <div
    class="cbg-white-container input-container theme--light v-card border-card"
  >
    <v-col cols="12">
      <v-row>
        <CCol sm="6" md="3">
          <div>
            <label for>Mobile No.</label>
            <v-text-field
              ref="useForm"
              v-model="mobileNumber"
              maxlength="10"
              placeholder="Number"
              required
              outlined
              :rules="mobileRules"
              :readonly="readonlyMobile"
            />
          </div>
        </CCol>
        <CCol sm="6" md="3">
          <v-btn
            v-if="!clearDataBtn"
            @click="getOtp()"
            class="btn btn-primary mt-7"
            >Get OTP</v-btn
          >
          <v-btn v-else class="btn btn-danger mt-7" @click="clearData()"
            >Clear Data</v-btn
          >
        </CCol>
      </v-row>
    </v-col>

    <v-col v-if="!!showDetails" cols="12">
      <div class="table-div overflow-auto">
        <table class="table">
          <thead>
            <tr class="table-success">
              <th>Name</th>
              <th>Mobile No.</th>
              <th>Mobile Verified</th>
              <th>Date</th>
              <th>OTP</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ userDetails.full_name }}</td>
              <td>{{ userDetails.mobile }}</td>
              <td>{{ userDetails.is_mobile_verified ? "Yes" : "No" }}</td>
              <td>{{ getDate(userDetails.updatedAt) }}</td>
              <td>{{ userDetails.otp || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-col>
    <v-col v-if="!!showDetails && requestAccessOtps.length" cols="12">
      <div class="table-div overflow-auto">
        <label class="font-weight-bold">Request Access OTPs</label>
        <table class="table">
          <thead>
            <tr class="table-success">
              <th>Doctor</th>
              <th>Source</th>
              <th>Role</th>
              <th>OTP</th>
              <th>Verified</th>
              <th>Status</th>
              <th>Expiry</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in requestAccessOtps" :key="item.notification_id">
              <td>{{ item.doctor_name || "-" }}</td>
              <td>{{ otpSourceLabel(item.type) }}</td>
              <td>{{ item.role || "-" }}</td>
              <td>{{ item.otp || "-" }}</td>
              <td>{{ item.is_verified ? "Yes" : "No" }}</td>
              <td>{{ item.status || "-" }}</td>
              <td>{{ item.otp_expiry ? getDate(item.otp_expiry) : "-" }}</td>
              <td>{{ item.created_at ? getDate(item.created_at) : "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-col>

    <v-col>
      <div>
        <loader v-if="showLoader"></loader>
      </div>
    </v-col>
  </div>
</template>

<script>
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const loader = () => import("@/components/loader.vue");
import Swal from "sweetalert2";
import config from "@/config.js";
export default {
  data() {
    return {
      userDetails: {},
      requestAccessOtps: [],
      mobileNumber: "",
      showDetails: false,
      showLoader: false,
      clearDataBtn: false,
      readonlyMobile: false,
      mobileRules: [
        (v) => !!v || "Mobile no is required",
        (v) => !isNaN(v) || "Please enter valid mobile number",
        (v) => v.length == 10 || "Please enter valid mobile number",
      ],
    };
  },
  components: {
    loader,
  },
  methods: {
    getOtp() {
      if (this.$refs.useForm.validate()) {
        this.showLoader = true;
        let obj;
        obj = {
          mobile: this.mobileNumber,
        };
        let url = `${config.BASE_URL}api/v2/admin/users/details`;
        this.$http
          .post(url, obj)
          .then((response) => {
            if (!!response.body.status) {
              this.userDetails = response.body.data.userDetails;
              this.requestAccessOtps =
                response.body.data.request_access_otps || [];
              this.showDetails = true;
            } else {
              this.$swal({
                text: response.body.message || "User not found",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "Ok",
              });
            }
            this.showLoader = false;
            this.clearDataBtn = true;
            this.readonlyMobile = true;
          })
          .catch((err) => {
            console.log(err);
            this.showLoader = false;
            this.$swal({
              text:
                (err.body && err.body.message) ||
                "Something went wrong while fetching user details",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok",
            });
          });
      }
    },
    clearData() {
      this.$refs.useForm.resetValidation();
      this.clearDataBtn = false;
      this.mobileNumber = "";
      this.userDetails = "";
      this.requestAccessOtps = [];
      this.showDetails = false;
      this.readonlyMobile = false;
    },
    getDate(date) {
      return dayJS(date).format("DD-MM-YYYY h:mm A");
    },
    otpSourceLabel(type) {
      const labels = {
        NOTIFICATION_CRN_REQUEST: "Patient Search",
        DOCTOR_BOOKING_CRN_REQUEST: "Appointment Booking",
      };
      return labels[type] || type || "-";
    },
  },
};
</script>